// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__iCOck typography_text--xs__Ts3SD"};